import { render } from "./PopupError.vue?vue&type=template&id=1874cfd4&scoped=true"
import script from "./PopupError.vue?vue&type=script&lang=js"
export * from "./PopupError.vue?vue&type=script&lang=js"

import "./PopupError.vue?vue&type=style&index=0&id=1874cfd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1874cfd4"]])

export default __exports__